import styled from 'styled-components';
import { styled as muiStyled } from '@mui/material/styles';

export const StyledAddAttendanceChipArea = styled.div`
  .chip-wrapper {
  }
`;

export const StyledListItem = muiStyled('li')(({ theme }) => ({
  margin: theme.spacing(0.5)
}));
